"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _basePath = _interopRequireDefault(require("../common/constants/basePath"));

var _ListOrganisations = _interopRequireDefault(require("./ListOrganisations"));

var _EditOrganisation = _interopRequireDefault(require("./EditOrganisation"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = [{
  exact: true,
  component: _ListOrganisations.default,
  path: "".concat(_basePath.default, "/organisations")
}, {
  component: _EditOrganisation.default,
  path: "".concat(_basePath.default, "/organisations/edit/new"),
  exact: true
}, {
  component: _EditOrganisation.default,
  path: "".concat(_basePath.default, "/organisations/edit/:id")
}];
exports.default = _default;